export default __webpack_public_path__ + "static/media/pokemon-card.4377df4e.png";